import React, { useState } from 'react';
import { SearchInput } from './TableHeader/styles';
import { Column } from '@tanstack/react-table';

type Props<TData, TValue> = {
  column: Column<TData, TValue>;
  placeholder?: string;
  regexp?: RegExp;
};

const TanstackTableFilter = <TData, TValue>({ column, placeholder, regexp }: Props<TData, TValue>): JSX.Element => {
  const [inputValue, setInputValue] = useState('');

  const handleInputChange: React.ChangeEventHandler<HTMLInputElement> = (e): void => {
    const { value } = e.currentTarget;

    if (value === '') {
      setInputValue('');
      return;
    }

    if (!regexp || regexp.test(value)) {
      setInputValue(value);
    }
  };

  const handleKeyDown: React.KeyboardEventHandler<HTMLInputElement> = (e): void => {
    if (e.key !== 'Enter') return;

    const { value } = e.currentTarget;

    column.setFilterValue(value);
  };

  const filterValue = column.getFilterValue();

  React.useEffect(() => {
    if (filterValue === undefined) {
      setInputValue('');
    }
  }, [filterValue]);

  return (
    <SearchInput value={inputValue} onChange={handleInputChange} onKeyDown={handleKeyDown} placeholder={placeholder} />
  );
};

export default TanstackTableFilter;
